import { defineCatalogue } from '../../../i18n';

export const overviewCatalogue = defineCatalogue(
  {
    heading: 'Mapa de influência',
    loading: 'Carregando o mapa de influência',
    'absent.reading': 'sem leitura',

    'window.label': 'Janela',
    'window.6h': 'Últimas 6 horas',
    'window.1d': 'Último dia',
    'window.3d': 'Últimos 3 dias',
    'window.7d': 'Últimos 7 dias',

    'figure.reach': 'Visualizações',
    'figure.posts': 'Publicações',
    'figure.accounts': 'Contas amplificadoras',
    'figure.sentiment': 'Sentimento',
    'delta.previous': 'Antes: {previous}',

    'movement.title': 'Movimento',
    'movement.chart': 'Movimento por hora',
    'movement.value': 'Visualizações',

    'groups.title': 'Grupos',
    'groups.accounts.one': '{n} conta',
    'groups.accounts.other': '{n} contas',
    'groups.open': 'Abrir contas de {group} em Contas monitoradas',

    'territory.title': 'Território',
    'territory.scope': 'Região das contas',
    'territory.open': 'Abrir Território',
  },
  {
    heading: 'Influence map',
    loading: 'Loading the influence map',
    'absent.reading': 'no reading',

    'window.label': 'Window',
    'window.6h': 'Last 6 hours',
    'window.1d': 'Last day',
    'window.3d': 'Last 3 days',
    'window.7d': 'Last 7 days',

    'figure.reach': 'Views',
    'figure.posts': 'Posts',
    'figure.accounts': 'Amplifying accounts',
    'figure.sentiment': 'Sentiment',
    'delta.previous': 'Before: {previous}',

    'movement.title': 'Movement',
    'movement.chart': 'Movement by hour',
    'movement.value': 'Views',

    'groups.title': 'Groups',
    'groups.accounts.one': '{n} account',
    'groups.accounts.other': '{n} accounts',
    'groups.open': 'Open {group} accounts in Monitored accounts',

    'territory.title': 'Territory',
    'territory.scope': "Accounts' region",
    'territory.open': 'Open Territory',
  },
);

export const ov = overviewCatalogue.t;
export const ovPlural = overviewCatalogue.plural;
